//packages and libs
import {React, Component} from 'react'
import {BrowserRouter as Router, Switch, Route, Link} from "react-router-dom";

import Web3 from 'web3';

//components
import Header from '../../components/Header/Header'
import Tile from '../../components/Tile/Tile';
//assets

import notFoundGif from '../../assets/404.gif'
import './MyGlyphs.css';
import pxgABI from '../../assets/pxg-abi.json'




class MyGlyphs extends Component {
  constructor(props){
    super(props)
    this.state = {
        userGlyphIds:[],
        query_results: [],
        query: "",

    }

    this.grabUserGlyphs = this.grabUserGlyphs.bind(this)
   
  }
  

  
  async grabUserGlyphs(){
    const pxgAddress = "0xF38d6BF300d52bA7880b43cDDB3F94ee3C6C4Ea6"

    if (typeof window.ethereum !== 'undefined') {
    //   console.log('MetaMask is installed!');
      window.ethereum.request({ method: 'eth_requestAccounts' }).then(data=>{
          const accounts = data
          let walletAddress = accounts[0];
        //   console.log("walletAddress", walletAddress)


          window.web3 = new Web3(window.ethereum)

          let pxgContract = new window.web3.eth.Contract(pxgABI,pxgAddress)
        //   console.log("pxg contract", pxgContract)
    
          pxgContract.methods.balanceOf(walletAddress).call({from:walletAddress}).then(async (data)=>{
              let numGlyphs = data
            //   console.log("num glyphs", numGlyphs)
              let glyphIds = []
              for(let i = 0; i < numGlyphs; i++){
                let currGlyphId = await pxgContract.methods.tokenOfOwnerByIndex(walletAddress, i).call({from:walletAddress})
                glyphIds.push(currGlyphId)
              }
            
            var postData = {
            "ids": glyphIds
            }

            // console.log("postData:", postData)

            //grab the data for all of a user's glyphs
            await fetch("https://jittery-river-production.up.railway.app/glyph/batch", {
                method: 'POST', // *GET, POST, PUT, DELETE, etc.
                mode: 'cors', // no-cors, *cors, same-origin
                cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
                credentials: 'omit', // include, *same-origin, omit
                headers: {
                'Access-Control-Allow-Origin': '*'
                // 'Content-Type': 'application/x-www-form-urlencoded',
                },
                redirect: 'follow', // manual, *follow, error
                referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
                body: JSON.stringify(postData) // body data type must match "Content-Type" header
            })
            .then(response=>response.json())
            .then(data=>this.setState({query_results : data}))
            

            


        }).catch(error=>console.log(error))
      }).catch(error=>console.log(error));
     


      // return unclassifiedGlyphs
    }
  }

  componentDidMount(){
    this.grabUserGlyphs()
  }

  render(){
    
    return (
      <div className="MyGlyphs">
        
  
              <Header/>
              <div style={{fontSize:"65px", margin:"20px 0px 40px 0px", fontWeight:"900", letterSpacing:"3px"}}>Glyphs</div>
              { this.state.query_results.length ? <div></div> : <img style={{borderRadius:"5px", width:"35%", maxWidth:"350px", marginTop:"50px"}} src={notFoundGif} alt="Feeling Blue"/> }
              
              {/* TODOs: add link to glyph/:id page for each image, fix image sizing, fix descriptor font size and color. */}
              
              <div className="results">
              
                {this.state.query_results.map(element=><Tile key={element["id"]} element={element}/>)}
              </div>
        </div>
    
    
    );
  
  }
}

export default MyGlyphs;
